import { render, staticRenderFns } from "./nacini-nabavke-vozila.editor.vue?vue&type=template&id=e7238664&scoped=true&"
import script from "./nacini-nabavke-vozila.editor.vue?vue&type=script&lang=ts&"
export * from "./nacini-nabavke-vozila.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7238664",
  null
  
)

export default component.exports